<template>
    <div>

        <section class="feature-section section-odd">
            <div class="container">
                <div class="row ">
                    <div class="col-lg-7 text-center">
                        <figure class="mt-20" style="border: 1px #f2f2f2 solid">
<!--                          <img src="images/homepage/powerful-simplicity.png" width="100%"/>-->
                          <img src="images/homepage/schema-diff2.png" width="100%">
                        </figure>
                    </div>
                  <div class="col-lg-5 text-left p-r-30">
                    <h2 class="align-left">No More Breaking Changes</h2>
                    <p>
                      Fixing data types changes in source data is painful and time consuming, even supporting new fields or simply loading source data is a hurdle.
                    <p>
                      We have a love/hate relationship with json and CSV. We want flexibility in our data generation, but need optimised Parquet and strong schemas for analysis.
                    </p>
                  </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'SchemaDrift',
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
